import { Line } from 'react-chartjs-2';

export default function LineChart(props) {
  const { chartData, chartOptions } = props;

  return <Line data={chartData} options={chartOptions} />;
}
